module.exports = {
  props: {
    tabName: {
      required: true,
      type: String,
    },
  },
  methods: {
    nextTab()
    {
      this.$emit('tabNavigation', {
        current: this.tabName,
        direction: 'next',
      })
    },
    previousTab()
    {
      this.$emit('tabNavigation', {
        current: this.tabName,
        direction: 'back',
      })
    },
  },
}